import React from 'react';

export const GlassPanel = ({ children, className = "", mood, ...props }) => (

  <div {...props}
    className={`
      relative overflow-hidden
      border border-white/5 border-t-white/15
      bg-gradient-to-b from-white/[0.03] to-transparent
      bg-black/40 ${mood.blur} shadow-2xl shadow-black/40
      ${className}
    `}>
    <div className="absolute inset-0 bg-[linear-gradient(115deg,transparent_40%,rgba(255,255,255,0.02)_45%,rgba(255,255,255,0.02)_50%,transparent_55%)] pointer-events-none" />
    {children}
  </div>
);
